






















import { Component, Prop, Vue } from "vue-property-decorator";
import ProfileBasic from "@/components/Profile/ProfileBasic.vue";
import ProfileContactInfo from "@/components/Profile/ProfileContactInfo.vue";
import ProfileBiography from "@/components/Profile/ProfileBiography.vue";
import ProfileExperience from "@/components/Profile/ProfileExperience.vue";
import ProfileEducation from "@/components/Profile/ProfileEducation.vue";
import ProfileLanguages from "@/components/Profile/ProfileLanguages.vue";
import ProfileInterests from "@/components/Profile/ProfileInterests.vue";
import ProfileCommunities from "@/components/Profile/ProfileCommunities.vue";
import { CMPRofileApi } from "@/services/api.service";
import { CMProfile } from "@/models/cm-profile.model";
import ModalEdit from "@/components/ModalEdit.vue";

@Component({
    components: {
        ProfileBasic,
        ProfileBiography,
        ProfileExperience,
        ProfileEducation,
        ProfileContactInfo,
        ProfileLanguages,
        ProfileInterests,
        ProfileCommunities,
        ModalEdit
    }
})
export default class MyProfile extends Vue {}
